import React from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames';

import css from './TeamAmPortrait.module.css';

/**
 * A member's portrait in a 4:5 frame.
 *
 * When `photo` is missing we show the member's initials on a plain background
 * instead, so a member without a picture still looks finished.
 */
const TeamAmPortrait = props => {
  const { className, photo, name, initials, children } = props;

  return (
    <div className={classNames(css.root, className)}>
      {photo ? (
        <img className={css.image} src={photo} alt={name} loading="lazy" />
      ) : (
        <div className={css.placeholder} aria-hidden="true">
          {initials}
        </div>
      )}
      {children}
    </div>
  );
};

TeamAmPortrait.defaultProps = {
  className: null,
  photo: null,
  children: null,
};

TeamAmPortrait.propTypes = {
  className: string,
  photo: string,
  name: string.isRequired,
  initials: string.isRequired,
  children: node,
};

export default TeamAmPortrait;
